import React from "react";
import TeamMember from "./TeamMember";
import NavBar from "./Navbar/NavBar";
import { Grid } from "@mui/material";
import FRITZ_PHOTO from "../images/team/fritz.png";
import JAN_PHOTO from "../images/team/jan.jpg";
import NITIN_PHOTO from "../images/team/nitin.jpg";
import DIRK_PHOTO from "../images/team/dirk.jpg";
import GURMEET_PHOTO from "../images/team/gurmeet.jpg";
// import JOACHIM_PHOTO from "../images/team/joachim.jpg";
import DAN_PHOTO from "../images/team/dan.jpg";
import PROF_BERNHARD from "../images/team/bernhard.jpg";

const teamData = [
  {
    name: "Fritz Schmid",
    designation:
      "Co-Founder/Engineering Lead | MS CS, Friedrich-Alexander-Universität Erlangen-Nürnberg",
    description:
      "A dynamic engineer currently pursuing a master's degree from FAU, Germany, is a passionate technology enthusiast. He thrives on coding and product development, turning ideas into practical solutions. Fritz's tech prowess and dedication make him a rising star set to impact the industry.",
    imageUrl: FRITZ_PHOTO,
    linkedinUrl: "https://www.linkedin.com/in/fritz-schmid-71b059186/",
  },
  {
    name: "Prof. Nitin Agarwal",
    designation:
      "Co-Founder/University Lead | Professor, PhD, San Jose State University",
    description:
      "Nitin holds a Ph.D. in business administration earned from Texas Tech University and possesses a profound expertise in Ed-Tech Technology, as well as policies and procedures. With a remarkable tenure spanning over 16 years at SJSU, he exhibits a deep-seated passion for Ed-Tech.",
    imageUrl:
      NITIN_PHOTO,
    linkedinUrl: "https://www.linkedin.com/in/nitin-aggarwal-721b073/",
  },
  {
    name: "Jan Kuenne",
    designation:
      "CEO Grundig Akademie Group Global",
    description:
      "Jan holds a Diploma in Education and multiple Certificates from MIT / Cambridge / ETF, in his career he acted for example as Vize President of the biggest European Broadcast Training Center SRT, Head of Strategy of biggest Swiss Media Production Company, cofounder of several companies and in his role as advisor and innovation consultant, he is focussed on Silicon Valley US, Europe and India.",
    imageUrl:
      JAN_PHOTO,
  },
  // {
  //   name: "Abhishek Chugg",
  //   designation:
  //     "Technical Engineering Support | MS CS, Carnegie Mellon University",
  //   description:
  //     "A distinguished graduate with an MS in Computer Science from Carnegie Mellon University, brings a wealth of experience to the table. With over a decade of experience at both Adobe and Google, Abhishek is leveraging his expertise to support and advance the FERPA product.",
  //   imageUrl:
  //     "https://media.licdn.com/dms/image/C5603AQH5fTNwG24fHg/profile-displayphoto-shrink_800_800/0/1601406761997?e=1700092800&v=beta&t=hkFEIBfcZIdK2866ye2Ls6ubXUGMzVDVgE0Jeju5kS0", // Add the image file for John Doe in your project's public folder
  //   linkedinUrl: "https://www.linkedin.com/in/abhishekchugh/",
  // },
  {
    name: "Prof. Dirk Holtbrügge",
    designation:
      "German Lead | Dean, International, Friedrich-Alexander-Universität Erlangen-Nürnberg",
    description:
      "Dirk is the lead of Copal.ai's German operations and is renowned for his extensive contributions in the Ed-Tech field. He has authored over 15 books and published more than 80 research papers, solidifying his status as an Ed-Tech domain expert.",
    imageUrl:
      DIRK_PHOTO,
    linkedinUrl: "https://www.linkedin.com/in/dirk-holtbr%C3%BCgge-b16324208/",
  },
  {
    name: "Gurmeet Naroola",
    designation:
      "Founder/Business Lead | EPGC – GSB Stanford, MSE from San Jose State University",
    description:
      "A seasoned entrepreneur with 15+ years of experience at companies like Apple, Panasonic, SunPower, and Sanmina driving $100M+ in revenue growth. He is incredibly passionate about the Ed-Tech/AI domain and making a difference to the lives of Professors and students.",
    imageUrl:
      GURMEET_PHOTO,
    linkedinUrl: "https://www.linkedin.com/in/gurmeet-naroola-6026551/",
  },
];

const advisorData = [
  // {
  //   name: "Prof. Dr. Joachim Hornegger",
  //   designation:
  //     "President, Friedrich-Alexander-Universität Erlangen-Nürnberg, #1 Innovator University of Europe",
  //   description:
  //     "Dr. Hornegger is a post doctorate from Stanford, doctorate from FAU, conducted research at MIT, worked as an executive from Siemens Medical, and held various academic roles. His expertise is at in Pattern Recognition.",
  //   imageUrl:
  //     JOACHIM_PHOTO,
  //   linkedinUrl: "https://www.linkedin.com/in/joachim-hornegger-b692ba2/",
  // },
  {
    name: "Prof. Dan Moshavi",
    designation: "Dean, San Diego State University, Fowler College of Business",
    description:
      "Prof Moshavi has a Ph.D. in Management from the University of Oregon, along with an MBA from George Washington University. His areas of expertise are strategic leadership, workplace attitudes and service management.",
    imageUrl:
      DAN_PHOTO,
    linkedinUrl: "https://www.linkedin.com/in/dan-moshavi-3360159/",
  },
  {
    name: "Prof. Bernhard Egger",
    designation:
      "Professor in Cognitive Computer Vision, Friedrich-Alexander-Universität Erlangen-Nürnberg",
    description:
      "Bernhard holds a PhD in Computer Science from the University of Basel in Switzerland, spent 4 years at MIT in the Computer Science & Artificial Intelligence Lab (CSAIL) as well as the Department of Brain and Cognitive Sciences. He joined FAU in 2021, is passionate about teaching and brings AI, machine learning and computer vision expertise to the team.",
    imageUrl:
      PROF_BERNHARD,
  },
];

function TeamPage() {
  return (
    <>
      <NavBar />
      <div className="my-4 py-4" data-aos="zoom-in">
        <h2
          className="my-2 text-center text-3xl text-blue-900 uppercase font-bold"
          style={{ marginTop: "50px" }}
        >
          team
        </h2>

        <div className="flex justify-center">
          <div className="w-24 border-b-4 border-blue-900"></div>
        </div>
        <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-blue-900">
          We combine German engineering excellence and Silicon Valley
          entrepreneurial spirit
        </h2>
      </div>
      <div
        style={{
          marginTop: "50px",
        }}
        data-aos="zoom-in"
        data-aos-delay="100"
      >
        <Grid
          container
          direction="row"
          md={12}
          sx={{
            justifyContent: "space-evenly",
          }}
        >
          {teamData.map((member, index) => (
            <Grid item md={4}>
              <TeamMember
                key={index}
                name={member.name}
                designation={member.designation}
                description={member.description}
                imageUrl={member.imageUrl}
                linkedinUrl={member.linkedinUrl}
              />
            </Grid>
          ))}
        </Grid>
      </div>
      <div className="my-4 py-4" data-aos="zoom-in">
        <h2
          className="my-2 text-center text-3xl text-blue-900 uppercase font-bold"
          style={{ marginTop: "50px" }}
        >
          board of advisors
        </h2>

        <div className="flex justify-center">
          <div className="w-24 border-b-4 border-blue-900"></div>
        </div>
      </div>
      <div
        style={{
          marginTop: "50px",
        }}
        data-aos="zoom-in"
        data-aos-delay="100"
      >
        <Grid
          container
          direction="row"
          md={12}
          sx={{
            justifyContent: "space-evenly",
          }}
        >
          {advisorData.map((member, index) => (
            <Grid
              item
              md={4}
              sx={{
                marginBottom: "50px",
              }}
            >
              <TeamMember
                key={index}
                name={member.name}
                designation={member.designation}
                description={member.description}
                imageUrl={member.imageUrl}
                linkedinUrl={member.linkedinUrl}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
}

export default TeamPage;
